export default "__VITE_ASSET__CZ_gCtsB__"